// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mMQO","placeholdersHeader":"styles_placeholdersHeader__1Vo1B","editorStyle":"styles_editorStyle__IixAJ","placeholdersBox":"styles_placeholdersBox__1Hweo"};